// Creates SVG cubic Bézier curve path between two points
export function createCurvedPath(startX, startY, endX, endY) {
  const minCurveDistance = 80 // Minimum horizontal distance for curve control points
  const horizontalDistance = endX - startX
  const controlPointOffset = Math.max(minCurveDistance, horizontalDistance * 0.5)

  const firstControlPointX = startX + controlPointOffset
  const firstControlPointY = startY
  const secondControlPointX = endX - controlPointOffset
  const secondControlPointY = endY

  return `M ${startX} ${startY} C ${firstControlPointX} ${firstControlPointY}, ${secondControlPointX} ${secondControlPointY}, ${endX} ${endY}`
}

// Calculate connection line coordinates between two nodes
export const calculateConnectionPath = (fromNode, toNode) => {
  const startX = fromNode.x + fromNode.w // Right edge of source node
  const startY = fromNode.y + fromNode.h / 2 // Vertical center of source node
  const endX = toNode.x // Left edge of target node
  const endY = toNode.y + toNode.h / 2 // Vertical center of target node

  return createCurvedPath(startX, startY, endX, endY)
}

// Generate SVG path element properties for connection lines between nodes
export const createConnectionProps = link => ({
  d: calculateConnectionPath(link.from, link.to),
  fill: 'none',
  stroke: link.color,
  strokeWidth: 2,
  opacity: 0.85
})
